__turbopack_context__.v({
  "footerTop": "PlasmicFooterTop-module__LuhifG__footerTop",
  "footerTopDownload": "PlasmicFooterTop-module__LuhifG__footerTopDownload",
  "footerTopNav": "PlasmicFooterTop-module__LuhifG__footerTopNav",
});
